<h1 mat-dialog-title>Benutzer {{data ? 'editieren' : 'erstellen'}}</h1>
<div mat-dialog-content>
  <knust-edit-user-form (cancelClick)="close()" (saveClick)="close()"
                        [user]="data" [showCancel]="true">
  </knust-edit-user-form>
</div>
